import { Dispatch, SetStateAction, useEffect } from 'react';
import Pill from '../../components/common/Pill';
import GapAround from '../../components/hoc/GapAround';
import { useMediaQueries } from '../../contexts/media-query';
const types = [
  'All',
  'Web Development',
  'Mobile App Development',
  'UI/UX Design',
  'Latest Technologies',
  'Digital Marketing',
  'Software Development',
];
const selectedClass = 'bg-yellow';
const defaultClass = 'border border-border-gray hover:cursor-pointer';
const marginTop = '25px';

interface BlogTypes {
  setSelectedType: Dispatch<SetStateAction<string>>;
  selectedType: string;
  page?: number;
  setPage?: Dispatch<SetStateAction<number>>;
}

const BlogTypes = ({ setSelectedType, selectedType, page, setPage }: BlogTypes) => {
  const { isLessThan640, isLessThan1150, bigColumnClass } = useMediaQueries();
  const containerClass = isLessThan1150 ? 'mx-3' : '';
  const containerStyle = bigColumnClass
    ? bigColumnClass
    : {
        marginBottom: '50px',
      };

    useEffect(() => {
    if (page && setPage) {
      setPage(1);
    }
  }, [selectedType]);
  return (
    <div className={containerClass}>
      <GapAround spaceTaken={2} containerStyle={containerStyle}>
        <div className={`flex gap-2 flex-wrap`} style={{ marginTop: marginTop }}>
          {types.map((type) => {
            const isSelected = type === selectedType;
            return (
              <Pill
                onClick={() => setSelectedType(type)}
                key={type}
                containerClasses={isSelected ? selectedClass : defaultClass}
                typographyStyles={{
                  color: isSelected ? 'black' : '#728F8B',
                  fontSize: 14,
                  padding: isLessThan640 ? '4px 8px' : '8px 16px',
                }}>
                {type}
              </Pill>
            );
          })}
        </div>
      </GapAround>
    </div>
  );
};

export default BlogTypes;
